var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sdg-item"},[_c('sdg-icon',{staticClass:"sdg-icon",attrs:{"sdg":_vm.sdg}}),_c('span',{staticClass:"sdg-title"},[_vm._v(_vm._s(_vm.sdgTitle))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }